export const deepSortObject = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) return obj
  if (Array.isArray(obj)) return obj.map(deepSortObject)
  return Object.fromEntries(
    Object.entries(objectSortedByKeys(obj)).map(([key, child]) => {
      if (typeof child === 'object') return [key, deepSortObject(child)]

      return [key, child]
    }),
  )
}

const objectSortedByKeys = (obj: Object) =>
  Object.fromEntries(
    Object.entries(obj).sort(([keyA], [keyB]) => keyA.localeCompare(keyB)),
  )
